module.exports = __webpack_public_path__ + "static/media/theme-modern.45c1ac7d.png";